// Typography per Axiom Design Core v2.0 (2026-09-08):
//   Source Sans 3 — Latin UI face (was IBM Plex Sans; Inter retired)
//   IBM Plex Sans Thai — Thai script coverage (kept)
//   IBM Plex Mono — kept as a non-template fallback for the mono face
//
// The canonical sans is now Source Sans 3, served via Google Fonts in
// fonts.css / index.html. Local @fontsource blocks are kept only for
// Thai glyph coverage (the Thai script range isn't included in the
// Google Fonts Source Sans 3 subset) and as a Plex Mono fallback when
// Google Fonts is unreachable.
import "@fontsource/ibm-plex-sans-thai/400.css";
import "@fontsource/ibm-plex-sans-thai/500.css";
import "@fontsource/ibm-plex-sans-thai/600.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
import "@fontsource/ibm-plex-mono/600.css";

import "./styles/fonts.css"; // Source Sans 3 + Spectral + JetBrains + Plex Thai (Google Fonts)
import "./styles/tokens.css";
import "./styles/layout.css";
import "maplibre-gl/dist/maplibre-gl.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root element not found");
createRoot(rootEl).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
